import COMPONENT_DATA from './components/modal.js';

(async function () {
  customElements.define(
    ('component-name' in document.currentScript.dataset?document.currentScript.dataset['component-name']:'dsb-modal'),
    COMPONENT_DATA
  );
})();
